module.exports = __webpack_public_path__ + "static/media/RRD5.975ada3d.jpg";